<!--
@Description: 相似商品列表
@Author: 吳廣帥
@Date:2021/12/29 - 17:07
@Name:similarGoodsList
@Version:v1.0
-->
<style scoped lang="less">
/** 最外层div盒子*/
.similar-list{
  padding: 0 0.24rem;
  &__item{
    position: relative;
    padding: 0.32rem;
    display: flex;
    flex-direction: row;
    &__index{
      top: 0.16rem;
      left: 0.06rem;
      position: absolute;
      font-size: 0.2rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2877FF;
      line-height: 0.2rem;
    }
    &__image{
      width: 0.96rem;
      height: 0.96rem;
      object-fit: cover;
      border-radius: 0.08rem;
      border: 0.02rem solid #E7E7E7;
      margin-right: 0.16rem;
    }
    &__info{
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &__title{
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #141B27;
        line-height: 0.28rem;
        width: 5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &__sub-title{
        margin-top: 0.24rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        &__money{
          width: 2rem;
          font-size: 0.32rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FF5500;
          line-height: 0.32rem;
        }
        &__label{
          font-size: 0.24rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #696D75;
          line-height: 0.24rem;
          margin-left: 0.48rem;
        }
        &__sub-money{
          margin-left: 0.08rem;
          font-size: 0.24rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FF5500;
          line-height: 0.24rem;
        }
      }
    }
  }
  .line{
    width: 100%;
    height: 0.01rem;
    background: #EDEDEE;
  }
}
</style>
<template>
  <!--  组件最外层盒子-->
  <div>
    <template v-if="similarGoodsData.length">
    <div class="similar-list"  v-for="(item,index) of similarGoodsData" :key="index">
      <router-link :to="item.link" class="similar-list__item" >
        <div class="similar-list__item__index">{{index + 1}}</div>
        <!--      图片      -->
        <img :src="item.image" class="similar-list__item__image">
        <!--     数据信息       -->
        <div class="similar-list__item__info">
          <div class="similar-list__item__info__title">{{item.title}}</div>
          <div class="similar-list__item__info__sub-title">
            <div class="similar-list__item__info__sub-title__money">¥{{ item.price }}</div>
            <div class="similar-list__item__info__sub-title__label">直播销售额</div>
            <div class="similar-list__item__info__sub-title__sub-money">¥{{ item.sales }}</div>
          </div>
        </div>
      </router-link>
      <div class="line" />
    </div>
    </template>
     <NoneData :height="5" v-else/>
  </div>
</template>
<script>
export default {
  /** 数据区 **/
  props: {
    data:{ type:Array, default: _ => ([]) }
  },
  computed: {
    similarGoodsData: (_this = this) => ( _this.$_.sortBy(_this.$props.data, ele => -ele.sales).map( ele => ({
      image: ele.image ? ele.image : _this.$defaultSrc,
      title: ele.title || '-',
      price: ele.price ?  ele.price : '-',
      sales: ele.sales ? _this.$retainWan(ele.sales) : '-',
      link: ele.itemId ? `/goods/${ele.itemId}` : ''
    })))
  },
}
</script>








